<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" v-bind:href="'#t1'+rowData.doc_id+''" role="tab" data-toggle="tab">
						<span class="nav-link-in">
							Documentos Vinculados
							<i class="fa fa-plus"></i>
						</span>
					</a>
				</li>
			</ul>

				<div class="tab-content">
					<div role="tabpanel" class="tab-pane fade in active show" v-bind:id="'t1'+rowData.doc_id+''">
                            <table class="table" id="mais">
                                <thead>
                                    <tr>
                                        <th style="width: 10%">N° Controle</th>
                                        <th style="width: 15%">N° Fiscal</th>
                                        <th style="width: 15%">Série</th>
                                        <th style="width: 15%">Observação</th>
                                        <th style="width: 15%">Prazo</th>
                                        <th style="width: 15%">Chave CTE</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                     <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.fatura_doc">
                                        <td>
                                         {{ item.doc.num_controle }}
                                        </td>
                                        <td>
                                          {{ item.doc.num_fiscal }}
                                        </td>
                                        <td>
                                          {{ item.doc.serie }}
                                        </td>
                                        <td>
                                          {{ rowData.obs }}
                                        </td>
                                        <td>
                                          {{ rowData.prazo_dias }}
                                        </td>
                                        <td>
                                          {{ item.doc.doc_cte.chave }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table" id="mais">
                                <thead>
                                    <tr>
                                        <th style="width: 100%">Observação</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                     <tr class="bg-gray-light" style="display: table-row;">
                                        <td>
                                          {{ rowData.obs }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table" id="mais">
                                <thead>
                                    <tr>
                                        <th v-if="rowData.dt_integracao!==null" style="width: 30%">Data Integração</th>
                                        <th v-if="rowData.dt_cancelamento!==null" style="width: 30%">Data Cancelamento</th>
                                        <th v-if="rowData.dt_integracao_can!==null" style="width: 20%">Data Integração Cancelamento</th>
                                        <th v-if="rowData.usuario_id_can!==null" style="width: 20%">Usuario Cancelamento</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                     <tr class="bg-gray-light" style="display: table-row;">
                                        <td v-if="rowData.dt_integracao!==null">
                                          {{ formatDate(rowData.dt_integracao) }}
                                        </td>
                                        <td v-if="rowData.dt_cancelamento!==null">
                                          {{ formatDate(rowData.dt_cancelamento) }}
                                        </td>
                                        <td v-if="rowData.dt_integracao_can!==null">
                                          {{ formatDate(rowData.dt_integracao_can) }}
                                        </td>
                                        <td v-if="rowData.usuario_id_can!==null">
                                          {{ rowData.usuario_canc.pessoa.pessoa_fisica.nome }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                    </div><!--.tab-pane-->
				</div><!--.tab-content-->
			</div>
    </div>
  </template>

  <script>
  import accounting from 'accounting'
  import moment from 'moment'
  export default {
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
      formatNumber (value) {
          return accounting.formatNumber(value, 2, '.', ',')
      },
      formatDate (value, fmt = 'D/MM/YYYY HH:mm') {
        return (value == null)
          ? ''
          : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
      }
    },
  }
  </script>
